import React, { useCallback } from 'react'
import { useForm } from '@mantine/form'

import { useI18n } from '@affiliate-cabinet/i18n'
import { FiltersPanel } from '@affstore-ds/uikit'

import { PromoBannersIdFiltersType, PromoLandingsFiltersFormInterface } from './PromoLandingsFiltersForm.types'

import { FilterButtons } from '../../../../../../../features/FilterButtons'
import { LocalesMultiSelect } from '../../../../../../../features/LocalesMultiSelect'
import { PromoBannerFileFormatsMultiSelect } from '../../../../../../../features/PromoBannerFileFormatsMultiSelect'
import { PromoBannerSizesMultiSelect } from '../../../../../../../features/PromoBannerSizesMultiSelect'
import { filtersTranslationKeys } from '../../../../../../../shared/translations/filters.translationKeys'
import { PROMO_BANNERS_ID_DEFAULT_FILTERS } from '../../constants/filters'

export const PromoBannersIdFiltersForm = ({ filters, onChange, loading, imageSizes }: PromoLandingsFiltersFormInterface) => {
  const { i18n } = useI18n()

  const form = useForm<PromoBannersIdFiltersType>({
    initialValues: {
      fileFormats: filters.fileFormats || PROMO_BANNERS_ID_DEFAULT_FILTERS.fileFormats,
      imageSizes: filters.imageSizes || PROMO_BANNERS_ID_DEFAULT_FILTERS.imageSizes,
      locales: filters.locales || PROMO_BANNERS_ID_DEFAULT_FILTERS.locales,
    },
  })

  const handleChange = useCallback(
    (values: PromoBannersIdFiltersType) => {
      onChange({ ...values })
    },
    [onChange],
  )

  return (
    <FiltersPanel
      title={i18n.t(filtersTranslationKeys.filtersTitle)}
      collapseShowText={i18n.t(filtersTranslationKeys.filtersCollapseShowText)}
      collapseHideText={i18n.t(filtersTranslationKeys.filtersCollapseHideText)}
      variant="responsive"
      onSubmit={form.onSubmit(handleChange)}
      data-testid="promo-banner-item-filters"
      filtersNotCollapsibleSlot={
        <>
          <LocalesMultiSelect name="locales" disabled={loading} {...form.getInputProps('locales')} />
          <PromoBannerSizesMultiSelect name="imageSizes" imageSizes={imageSizes} disabled={loading} {...form.getInputProps('imageSizes')} />
          <PromoBannerFileFormatsMultiSelect name="fileFormats" disabled={loading} {...form.getInputProps('fileFormats')} />
        </>
      }
      loading={loading}
      filtersButtonsSlot={
        <FilterButtons
          variant="responsive"
          form={form}
          resetFormValues={PROMO_BANNERS_ID_DEFAULT_FILTERS}
          filters={filters}
          loading={loading}
          omittedToCheckFormValues={['first', 'skip']}
        />
      }
    />
  )
}
